import React from 'react';
import styles from './AdminInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import PhoneInput from '../../../../components/PhoneInput';
import cn from 'classnames';

const AdminInformations = ({ partner, onPartnerChange , loading, hasChanges}) => {
    return (
        <Card className={styles.card} title="Informations de l'administrateur" classTitle="title-green">
            <div className={styles.group}>
                <TextInput
                    className={styles.field}
                    label="Nom de l'administrateur"
                    name="admin_contact_name"
                    type="text"
                    placeholder="Nom complet de l'administrateur"
                    value={partner?.admin_contact_name || ''}
                    onChange={onPartnerChange}
                    required
                />
                <TextInput
                    className={styles.field}
                    label="Email de l'administrateur"
                    name="admin_contact_email"
                    type="email"
                    placeholder="admin@example.com"
                    value={partner?.admin_contact_email || ''}
                    onChange={onPartnerChange}
                    required
                />
                <PhoneInput
                    className={styles.field}
                    label="Téléphone de l'administrateur"
                    name="admin_contact_phone"
                    id="admin_phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={partner?.admin_contact_phone || ''}
                    onChange={onPartnerChange}
                    autoComplete="tel"
                />
            </div>
            <div className={styles.divider}></div>

            <div className={styles.submitContainer}>
                <button
                    className={cn("button", styles.submit, {
                        [styles.disabled]: !hasChanges
                    })}
                    type="submit"
                    disabled={loading || !hasChanges}
                >
                    {loading ? "Sauvegarde en cours..." : hasChanges ? "Sauvegarder les modifications" : "Aucune modification"}
                </button>
            </div>
        </Card>
    );
};

export default AdminInformations;